export default "__VITE_ASSET__e07b83a5__"